import { computed } from "vue";
import { useRoute } from "vue-router";

import { GA4Tracker } from "ic-analytics";

export function useGA4Tracking() {
    const route = useRoute();
    const clientId = computed(() => route.params.clientId as string);

    return {
        trackFeatureEvent: ({
            featureEvent,
            featureCategory,
            featureContext,
            freeformValues
        }: {
            featureEvent: string;
            featureCategory: string;
            featureContext: string;
            freeformValues?: (string | number)[];
        }) => {
            const ga4TrackerInstance = GA4Tracker.getInstance();

            ga4TrackerInstance.trackFeatureEvent({
                featureEvent,
                featureCategory,
                featureContext,
                freeformValues,
                clientId: clientId.value
            });
        },

        trackClickEvent: ({
            interactionObject,
            interactionText
        }: {
            interactionObject: string;
            interactionText: string;
        }) => {
            const ga4TrackerInstance = GA4Tracker.getInstance();

            ga4TrackerInstance.trackClick({
                interactionObject,
                interactionText,
                interactionTargetPath: route.path,
                clientId: clientId.value
            });
        },

        trackError: ({
            errorMessage,
            errorType,
            origin,
            featureName
        }: {
            errorMessage: string;
            errorType: "validation_error" | "system_error" | "network_error";
            origin: "frontend" | "backend" | "third_party";
            featureName: string;
        }) => {
            const ga4TrackerInstance = GA4Tracker.getInstance();

            ga4TrackerInstance.trackError({
                errorMessage,
                errorType,
                origin,
                featureName,
                pageLocation: route.path,
                clientId: clientId.value
            });
        },

        trackSegmentInteraction: ({
            segmentId,
            segmentName,
            interactionType,
            segmentCategory
        }: {
            segmentId: string;
            segmentName: string;
            interactionType: string;
            segmentCategory: string;
        }) => {
            const ga4TrackerInstance = GA4Tracker.getInstance();

            ga4TrackerInstance.trackSegmentInteraction({
                segmentId,
                segmentName,
                interactionType,
                segmentCategory,
                pageLocation: route.path,
                clientId: clientId.value
            });
        }
    };
}
